import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

/**
 * Singleton MSAL PublicClientApplication instance.
 * Uses Authorization Code flow with PKCE by default (MSAL.js v2+).
 */
export const msalInstance = new PublicClientApplication(msalConfig);

// Set the first account as the active account after login
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  }
});

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * AuthProvider wraps the application with MsalProvider,
 * providing MSAL authentication context to all child components.
 */
export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};
